import { ChangeEvent } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { FieldValidation } from '@rjsf/utils';

/**
 * Available AI use case categories for AIAgent templates.
 */
export const AI_USE_CASE_CATEGORIES = [
  'Classification',
  'Summarization',
  'Sentiment analysis',
  'Translation',
  'Data extraction',
  'Chatbot',
  'Writing',
  'Reasoning',
  'Other',
] as const;

export type UseCaseCategoryProps = {
  /** Currently selected value */
  value: string;
  /** Called when the selection changes */
  onChange: (value: string) => void;
};

/**
 * Dropdown for selecting an AI Use Case Category.
 */
export const UseCaseCategory = ({ value, onChange }: UseCaseCategoryProps) => {
  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl variant="outlined" style={{ width: '100%' }} required>
      <InputLabel id="use-case-category-label">AI Use Case Category</InputLabel>
      <Select
        labelId="use-case-category-label"
        id="use-case-category-select"
        value={value}
        onChange={handleChange}
        label="AI Use Case Category"
        data-testid="useCaseCategorySelect"
      >
        {AI_USE_CASE_CATEGORIES.map(category => (
          <MenuItem key={category} value={category}>
            {category}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

/**
 * Validation function for the use case category field.
 */
export const validateUseCaseCategory = (value: string, validation: FieldValidation) => {
  if (!value) {
    validation.addError('Please select an AI Use Case Category');
  }
};
